<template>
	<div v-if="loading" class="text-center">
	    <i class="fa fa-circle-o-notch fa-spin"></i> Loading
	</div>
	<div v-else>
		<div>
			<vue-headful :title="(inspection.InspectionId ? 'Edit Inspection: ' + inspection.InspectionId : 'New Inspection') + ' :: MeritEHS'"/>

			<h4 class="py-3 mb-4">
			    <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
			        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
			            <router-link :to="`/inspections`">
			                <i class="fa fa-list"></i> Inspections
			            </router-link>
			        </li>
			        <template v-if="inspection.InspectionId">
			            <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
			                <router-link :to="`/inspections/view/${inspection.InspectionId}`">
			                    <inspection-name :inspection="inspection" />
			                </router-link>
			            </li>
			            <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2"><i class="fa fa-edit"></i> Edit</li>
			        </template>
			        <template v-else>
			            <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2"><i class="fa fa-plus"></i> New</li>
			        </template>
			    </ol>
			</h4>

			<div class="row" v-if="!inspection.InspectionId && forms.length === 0">
				<div class="col-md-6 col-sm-7 col-12">
					<div class="card mb-3">
						<div class="card-body">
							<div class="alert alert-warning">
								You do not have any published Inspection Forms. An account admin needs to publish a form here:<br/>
								<router-link to="/inspections/forms/create"><i class="fa fa-plus"></i> Create Inspection Form</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<template v-else>
				<div class="row">
				    <div class="col-xl-10 col-12">
				        <!-- <div id="form-content" style="position:relative;"> -->
				        <div class="card mb-3">
				        	<div class="card-header">
				        		<strong><i class="fa fa-list"></i> Inspection</strong>
								<button type="button" class="btn btn-sm btn-success" v-on:click="saveInspection(this)" :disabled="saving">
								    <span v-if="InspectionId">Update</span>
								    <span v-else>Create</span>
								    Inspection
								</button>
				        	</div>
				        	<div class="card-body">
				        		<div class="form-group row">
				        		    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.inspection_form_id }">
				        		    	Inspection Form <i v-if="!inspection.inspection_form_id" class="fa fa-asterisk small text-danger"></i>
				        		    </label>
				        		    <div class="col-xl-6 col-sm-8" :class="{'pt-1': !forms}">
				        		    	<template v-if="forms">
				        		    			<select :class="{ 'is-invalid': errors.inspection_form_id, 'form-control': true}" v-model="inspection.inspection_form_id">
				        		    			    <option :value="null">-- Select An Inspection Form --</option>
				        		    			    <option v-for="(form, i) in formOptions" v-bind:value="form.inspection_form_id">
				        		    			        {{ form.form_name }}
				        		    			    </option>
				        		    			</select>

				        		    		    <span v-if="errors.inspection_form_id" class="text-danger">
				        		    		        <span v-for="error in errors.inspection_form_id">{{ error }}</span>
				        		    		    </span>
				        		    	</template>
				        		    	<template v-else>
				        		    		{{ inspection.form_name }}
				        		    	</template>
				        		    </div>
				        		</div>

				        		<div class="form-group row">
				        		    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.JobsiteId }">Select a Jobsite <i v-if="!inspection.JobsiteId" class="fa fa-asterisk small text-danger"></i></label>
				        		    <div class="col-xl-6 col-sm-8">

	        		    				<!-- <div class="input-group-addon">
	        		    	            	<a href="/jobsites/edit?callback=Crowder.setJobsiteTypeahead" title="Create a New Jobsite" onclick="return Crowder.getModal(this.href);"><i class="fa fa-plus"></i></a>
	        		    	            </div> -->
	        		    				<jobsite-select ref="inspJobsiteSelect" :selectedValues="JobsiteValues" @vselected="onJobSiteSelectUpdate" :hasError="errors.JobsiteId ? true : false" :filters="{'jobsite.IsActive': 1}"></jobsite-select>

				        		        <div v-if="errors.JobsiteId" class="text-danger">
				        		            <span v-for="error in errors.JobsiteId">{{ error }}</span>
				        		        </div>

				        		        <div class="mt-1 mb-1" v-if="!inspection.InspectionId && this.$root.hasPermission('jobsites.manage')">
				        		            <a href="javascript:void(0)" v-on:click="showNewJobsiteModal()"><small><i class="fa fa-plus"></i> Create a New Jobsite</small></a>
				        		        </div>

				        		        <div>
				        		            <jobsite-modal ref="newJobsiteModal" @jobsiteCreated="jobsiteCreated" :showButton="false" />
				        		        </div>
				        		    </div>
				        		</div>

				        		<hr>

				        		<div class="form-group row">
				        		    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Inspected By</label>
				        		    <div class="col-xl-6 col-sm-8 pt-1">
				        		        <user-name :user="user" v-if="inspection.hide_creator == 0 || $store.state.user.is_admin" />
				        		    </div>
				        		</div>

				        		<div class="form-group row">
				        		    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.status_id }">
				        		    	Status <i class="fa fa-question-circle" title="The Inspection Status is automatically determined by EHS based on the number of Open Corrective Actions. You no longer need to fill out this field."></i>
				        		    </label>
				        		    <div class="col-xl-6 col-sm-8 pt-1">
				        		    	{{ inspection.status_name }}

				        		        <span v-if="errors.status_id" class="text-danger">
				        		            <span v-for="error in errors.status_id">{{ error }}</span>
				        		        </span>
				        		    </div>
				        		</div>

				        		<div class="form-group row">
				        		    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.NumberOfEmployees }">
				        		    	# of Employees on Site <i v-if="form_settings.req_num_of_employees == 1 && !inspection.NumberOfEmployees" class="fa fa-asterisk small text-danger"></i>
				        		    </label>
				        		    <div class="col-xl-6 col-sm-8">
				        		    	<input :class="{ 'is-invalid': errors.NumberOfEmployees, 'form-control': true}" type="number" v-model="inspection.NumberOfEmployees" style="max-width: 150px;" placeholder="Number of Employees">

				        		        <span v-if="errors.NumberOfEmployees" class="text-danger">
				        		            <span v-for="error in errors.NumberOfEmployees">{{ error }}</span>
				        		        </span>
				        		    </div>
				        		</div>

				        		<div class="form-group row">
				        		    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.InspectionDate }">Date of Inspection <i v-if="!inspection.InspectionDate" class="fa fa-asterisk text-danger small"></i></label>
				        		    <div class="col-xl-6 col-sm-8">

				        		    	<div v-if="inspection.InspectionId">
				        		    		<input name="InspectionDate" type="text" class="form-control date-picker" :value="InspectionDate | moment('MM/DD/YYYY')" readonly="true">
				        		    	</div>

				        		    	<div v-else>
					        		    	<date-picker v-model="InspectionDate" :config="{format: 'MM/DD/YYYY', useCurrent: false}" :class="{ 'is-invalid': errors.InspectionDate }" placeholder="Inspection Date"></date-picker>
					        		    </div>

				        		        <span v-if="errors.InspectionDate" class="text-danger">
				        		            <span v-for="error in errors.InspectionDate">{{ error }}</span>
				        		        </span>
				        		    </div>
				        		</div>

				        		<div :class="{ 'form-group row': true, 'has-error': errors.superintendent_id }" v-if="form_settings.hide_superintendent != 1">
				        		    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.superintendent_id }">
				        		    	Superintendent <i v-if="!inspection.superintendent_id && form_settings.req_superintendent === 1" class="fa fa-asterisk text-danger small"></i>
				        		    </label>
				        		    <div class="col-xl-6 col-sm-8">

				        		        <employee-select ref="inspSuperSelect" :selectedValues="SuperintendentValues" @vselected="onSuperSelect" :hasError="errors.superintendent_id ? true : false" />

				        		        <span v-if="errors.superintendent_id" class="text-danger">
				        		            <span v-for="error in errors.superintendent_id">{{ error }}</span>
				        		        </span>

				        		        <template  v-if="this.$root.hasPermission('employees.manage')">
					        		        <div class="mt-1 mb-1">
					        		            <a href="javascript:void(0)" v-on:click="showNewSuperModal()"><small><i class="fa fa-plus"></i> Create a Superintendent</small></a>
					        		        </div>

					        		        <div>
					        		            <employee-modal ref="newSuperModal" @employeeCreated="superCreated" :showButton="false" />
					        		        </div>
				        		    	</template>
				        		    </div>
				        		</div>

				        		<div v-bind:class="{ 'form-group row': true, 'has-error': errors.equipment_id }" v-if="form_settings.hide_equipment != 1">
				        		    <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.equipment_id }">
				        		    	Equipment: <i class="fa fa-asterisk text-danger" v-if="form_settings.req_equipment"></i>
				        		    </label>
				        		    <div class="col-xl-6 col-sm-8">

				        		        <equipment-select :selectedValues="EquipmentValues" @vuselected="onEquipmentSelect" :hasError="errors.equipment_id ? true : false" />

				        		        <span v-if="errors.equipment_id" class="text-danger">
				        		            <span v-for="error in errors.equipment_id">{{ error }}</span>
				        		        </span>
				        		    </div>
				        		</div>

				        		<div class="form-group row">
				        		    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.GeneralContractor }">General Contractor <i v-if="!inspection.GeneralContractor" class="fa fa-asterisk text-danger small"></i></label>
				        		    <div class="col-xl-6 col-sm-8">

				        		    	<input :class="{ 'is-invalid': errors.GeneralContractor, 'form-control': true}" name="GeneralContractor" type="text" maxlength="100" class="form-control" v-model="inspection.GeneralContractor" placeholder="Enter General Contractor">

				        		        <span v-if="errors.GeneralContractor" class="text-danger">
				        		            <span v-for="error in errors.GeneralContractor">{{ error }}</span>
				        		        </span>
				        		    </div>
				        		</div>

				        		<div class="form-group row">
				        		    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">Subcontractors Onsite</label>
				        		    <div class="col-xl-6 col-sm-8">
				        		        <textarea v-model="inspection.subcontractors_onsite" name="subcontractors_onsite" class="form-control" placeholder="Enter active subcontractors onsite" style="min-height: 60px;">{{ inspection.subcontractors_onsite }}</textarea>
				        		    </div>
				        		</div>
				        	</div>
				        </div>

				        <personnel-form ref="inspPersonnelForm" />

				        <div class="card mb-3" v-if="enable_insp_scmm === 1">
				        	<div class="card-header"><strong>Safety Committee Meeting Minutes</strong></div>
				        	<div class="card-body">
				        		<div class="form-group row">
				        		    <label class="col-lg-4 col-md-4 col-sm-4 col-form-label text-sm-right">Was a Safety Committee Meeting conducted this week?</label>
				        		    <div class="col-xl-6 col-sm-8">
				        		        <b-form-radio-group v-model="inspection.scmm_conducted_meeting" plain class="mt-2">
				        		            <b-form-radio value="1">Yes</b-form-radio>
				        		            <b-form-radio value="0">No</b-form-radio>
				        		        </b-form-radio-group>
				        		    </div>
				        		</div>

				        		<div id="scmm_fields" :style="`display: ${inspection.scmm_conducted_meeting == 1 ? 'block' : 'none'};`">
				        			<div class="form-group row">
				        			    <label :class="{'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.scmm_date}">Safety Committee Meeting Date</label>
				        			    <div class="col-xl-6 col-sm-8">
				        			        <date-picker v-model="inspection.scmm_date" :config="{format: 'YYYY-MM-DD', useCurrent: false}" :class="{ 'is-invalid': errors.scmm_date }" placeholder="Meeting Date"></date-picker>

				        			        <span v-if="errors.scmm_date" class="text-danger">
				        			            <span v-for="error in errors.scmm_date">{{ error }}</span>
				        			        </span>
				        			    </div>
				        			</div>

				        			<div class="col-md-10 col-md-offset-1">
				        				<div class="alert alert-warning">
				        					Per CP028, the Safety Committee should at least include the following:  PM (Onsite Only); Site Superintendent; Foreman (1); Site Safety Coordinator; Craft Employees (2) and representatives from each active subcontractor.
				        				</div>
				        			</div>

				        			<div class="form-group" v-if="">
				        				<label :class="{'control-label': true, 'text-danger': errors.hacky_members}">Safety Committee:<br/></label>

				        				<div class="form-inline mb-2">
				        					<select v-model="new_safety_member.member_type" class="form-control mr-1">
				        						<option :value="null">-- Select Member Type --</option>
				        						<option value="Employee">Employee</option>
				        						<option value="User">User</option>
				        						<option value="FreeText">Free Text</option>
				        					</select>
				        					<div class="mr-1" style="width: 250px;" v-if="new_safety_member.member_type == 'Employee'">
				        						<employee-select ref="newMemberEmployee" @vselected="safetyMemberEmployee"></employee-select>
				        					</div>
				        					<div class="mr-1" style="width: 250px;" v-if="new_safety_member.member_type == 'User'">
				        						<user-select ref="newMemberUser" @vuselected="safetyMemberUser"></user-select>
				        					</div>
				        					<div class="mr-1" style="width: 250px;" v-if="new_safety_member.member_type == 'FreeText'">
				        						<input type="text" v-model="new_safety_member.member_name" class="form-control" placeholder="Member Name" />
				        					</div>
				        					<div class="mr-1" style="width: 250px;">
				        						<input type="text" v-model="new_safety_member.craft" class="form-control" placeholder="Craft" />
				        					</div>
				        					<div class="mr-1" style="width: 250px;">
				        						<input type="text" v-model="new_safety_member.company" class="form-control" placeholder="Company" />
				        					</div>
				        					<button type="button" class="btn btn-success" @click="addSafetyCommitteeMemberAlt" title="Add Member"><i class="fa fa-plus"></i> Add</button>
				        				</div>
				        				<hr/>

				        				<!-- forceupdate should not be needed here, but it doesn't work without it, if you find a better way, PLEASE get rid of it -->
				        				<div id="safety-committee-members">
				        					<div v-for="(member, key) in safetyMembers">
				        						<a href="javascript:void(0)" class="text-danger" @click="inspection.members.splice(key, 1); $forceUpdate()"><i class="fa fa-remove"></i></a>
				        						{{member.name}} | {{member.craft}} | {{member.company}}
				        					</div>
				        				</div>
				        			</div>

				        			<table class="table table-condensed table-bordered">
				        				<tbody>
				        					<tr>
				        						<td>A.</td>
				        						<td :class="{'text-danger': errors.scmm_status_of_actions_flag}">Discuss inspection results and status of project Corrective Actions:</td>
				        						<td>
				        							<b-form-radio-group v-model="inspection.scmm_status_of_actions_flag" plain class="mt-2">
							        		            <b-form-radio value="1">Yes</b-form-radio>
							        		            <b-form-radio value="0">No</b-form-radio>
							        		            <b-form-radio value="-1">N/A</b-form-radio>
							        		        </b-form-radio-group>

							        		        <span v-if="errors.scmm_status_of_actions_flag" class="text-danger">
							        		            <span v-for="error in errors.scmm_status_of_actions_flag">{{ error }}</span>
							        		        </span>
				        						</td>
				        					</tr>
				        					<tr v-if="inspection.scmm_status_of_actions_flag == 1">
				        						<td colspan="3">
				        							<textarea placeholder="Enter Text" :class="{ 'is-invalid': errors.scmm_status_of_actions, 'form-control': true}" v-model="inspection.scmm_status_of_actions" name="scmm_status_of_actions"></textarea>

				        							<span v-if="errors.scmm_status_of_actions" class="text-danger">
				        							    <span v-for="error in errors.scmm_status_of_actions">{{ error }}</span>
				        							</span>
				        						</td>
				        					</tr>
				        					<tr><td colspan="3" style="background: #f5f5f5;"></td></tr>

				        					<tr>
				        						<td>B.</td>
				        						<td :class="{'text-danger': errors.scmm_lessons_learned_flag}">Project incidents and lessons learned:</td>
				        						<td>
				        							<b-form-radio-group v-model="inspection.scmm_lessons_learned_flag" plain class="mt-2">
							        		            <b-form-radio value="1">Yes</b-form-radio>
							        		            <b-form-radio value="0">No</b-form-radio>
							        		            <b-form-radio value="-1">N/A</b-form-radio>
							        		        </b-form-radio-group>

							        		        <span v-if="errors.scmm_lessons_learned_flag" class="text-danger">
							        		            <span v-for="error in errors.scmm_lessons_learned_flag">{{ error }}</span>
							        		        </span>
				        						</td>
				        					</tr>
				        					<tr v-if="inspection.scmm_lessons_learned_flag == 1">
				        						<td colspan="3">
				        							<textarea placeholder="Enter Text" v-model="inspection.scmm_lessons_learned" name="scmm_lessons_learned" :class="{ 'is-invalid': errors.scmm_lessons_learned, 'form-control': true}"></textarea>
				        							<span v-if="errors.scmm_lessons_learned" class="text-danger">
				        							    <span v-for="error in errors.scmm_lessons_learned">{{ error }}</span>
				        							</span>
				        						</td>
				        					</tr>
				        					<tr><td colspan="3" style="background: #f5f5f5;"></td></tr>

				        					<tr>
				        						<td>C.</td>
				        						<td :class="{'text-danger': errors.scmm_suggested_safety_flag}">Safety concerns and suggestions voiced by any other project team member(s):</td>
				        						<td>
				        							<b-form-radio-group v-model="inspection.scmm_suggested_safety_flag" plain class="mt-2">
							        		            <b-form-radio value="1">Yes</b-form-radio>
							        		            <b-form-radio value="0">No</b-form-radio>
							        		            <b-form-radio value="-1">N/A</b-form-radio>
							        		        </b-form-radio-group>

							        		        <span v-if="errors.scmm_suggested_safety_flag" class="text-danger">
							        		            <span v-for="error in errors.scmm_suggested_safety_flag">{{ error }}</span>
							        		        </span>
				        						</td>
				        					</tr>
				        					<tr v-if="inspection.scmm_suggested_safety_flag == 1">
				        						<td colspan="3">
				        							<textarea placeholder="Enter Text" v-model="inspection.scmm_suggested_safety" name="scmm_suggested_safety" :class="{ 'is-invalid': errors.scmm_suggested_safety, 'form-control': true}"></textarea>
				        							<span v-if="errors.scmm_suggested_safety" class="text-danger">
				        							    <span v-for="error in errors.scmm_suggested_safety">{{ error }}</span>
				        							</span>
				        						</td>
				        					</tr>
				        					<tr><td colspan="3" style="background: #f5f5f5;"></td></tr>

				        					<tr>
				        						<td>D.</td>
				        						<td :class="{'text-danger': errors.scmm_upcoming_activities_flag}">Upcoming safety sensitive activities/tasks:</td>
				        						<td>
				        							<b-form-radio-group v-model="inspection.scmm_upcoming_activities_flag" plain class="mt-2">
							        		            <b-form-radio value="1">Yes</b-form-radio>
							        		            <b-form-radio value="0">No</b-form-radio>
							        		            <b-form-radio value="-1">N/A</b-form-radio>
							        		        </b-form-radio-group>

							        		        <span v-if="errors.scmm_upcoming_activities_flag" class="text-danger">
							        		            <span v-for="error in errors.scmm_upcoming_activities_flag">{{ error }}</span>
							        		        </span>
				        						</td>
				        					</tr>
				        					<tr v-if="inspection.scmm_upcoming_activities_flag == 1">
				        						<td colspan="3">
				        							<textarea placeholder="Enter Text" v-model="inspection.scmm_upcoming_activities" name="scmm_upcoming_activities" :class="{ 'is-invalid': errors.scmm_upcoming_activities, 'form-control': true}"></textarea>
				        							<span v-if="errors.scmm_upcoming_activities" class="text-danger">
				        							    <span v-for="error in errors.scmm_upcoming_activities">{{ error }}</span>
				        							</span>
				        						</td>
				        					</tr>
				        					<tr><td colspan="3" style="background: #f5f5f5;"></td></tr>

				        					<tr>
				        						<td>E.</td>
				        						<td :class="{'text-danger': errors.scmm_proactive_measures_flag}">Proactive safety measures being utilized throughout the project, and/or individuals who have displayed HSE leadership:</td>
				        						<td>
				        							<b-form-radio-group v-model="inspection.scmm_proactive_measures_flag" plain class="mt-2">
							        		            <b-form-radio value="1">Yes</b-form-radio>
							        		            <b-form-radio value="0">No</b-form-radio>
							        		            <b-form-radio value="-1">N/A</b-form-radio>
							        		        </b-form-radio-group>

							        		        <span v-if="errors.scmm_proactive_measures_flag" class="text-danger">
							        		            <span v-for="error in errors.scmm_proactive_measures_flag">{{ error }}</span>
							        		        </span>
				        						</td>
				        					</tr>
				        					<tr v-if="inspection.scmm_proactive_measures_flag == 1">
				        						<td colspan="3">
				        							<textarea placeholder="Enter Text" v-model="inspection.scmm_proactive_measures" name="scmm_proactive_measures" :class="{ 'is-invalid': errors.scmm_proactive_measures, 'form-control': true}"></textarea>
				        							<span v-if="errors.scmm_proactive_measures" class="text-danger">
				        							    <span v-for="error in errors.scmm_proactive_measures">{{ error }}</span>
				        							</span>
				        						</td>
				        					</tr>
				        					<tr><td colspan="3" style="background: #f5f5f5;"></td></tr>

				        					<tr>
				        						<td>F.</td>
				        						<td :class="{'text-danger': errors.scmm_other_flag}">Any other relevant topic discussed by the safety committee</td>
				        						<td>
				        							<b-form-radio-group v-model="inspection.scmm_other_flag" plain class="mt-2">
							        		            <b-form-radio value="1">Yes</b-form-radio>
							        		            <b-form-radio value="0">No</b-form-radio>
							        		            <b-form-radio value="-1">N/A</b-form-radio>
							        		        </b-form-radio-group>

							        		        <span v-if="errors.scmm_other_flag" class="text-danger">
							        		            <span v-for="error in errors.scmm_other_flag">{{ error }}</span>
							        		        </span>
				        						</td>
				        					</tr>
				        					<tr v-if="inspection.scmm_other_flag == 1">
				        						<td colspan="3">
				        							<textarea placeholder="Enter Text" v-model="inspection.scmm_other" name="scmm_other" :class="{ 'is-invalid': errors.scmm_other, 'form-control': true}"></textarea>
				        							<span v-if="errors.scmm_other" class="text-danger">
				        							    <span v-for="error in errors.scmm_other">{{ error }}</span>
				        							</span>
				        						</td>
				        					</tr>
				        				</tbody>
				        			</table>
				        		</div>
				        	</div>
				        </div>

				        <div v-if="custom_field_sections && !loading_custom_fields" class="mt-4">
				            <incident-sections-builder
				            	:sections="custom_field_sections"
				            	:initialValues="custom_fields"
				            	@customFieldsChanged="setCustomFields"
				            	:errors="errors"
				            	:fieldSize="'col-xl-6 col-sm-8'"
				            	:labelSize="'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right'" />
				        </div>

						<div v-if="inspection.InspectionId" class="card mb-3">
							<div class="card-header">
								<strong>Additional Notes</strong>
							</div>
							<div class="card-body">
								<div class="form-group row">
								    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.Comment}">Additional Notes/Comments</label>
								    <div class="col-xl-6 col-sm-8">
								        <textarea v-model="inspection.Comment" name="Comment" class="form-control" id="inspection_Comment" placeholder="Additional Comments (Optional)" style="min-height: 100px;"></textarea>

								        <span v-if="errors.Comment" class="text-danger">
								            <span v-for="error in errors.Comment">{{ error }}</span>
								        </span>
								    </div>
								</div>

								<div class="form-group row">
								    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">Add Files/Photos</label>
								    <div class="col-xl-6 col-sm-8">
								        <vue2-dropzone ref="inspAdditionalFiles"
								        	id="editInspDropzoneFiles"
								        	:options="dropzoneOptions"
								        	:useCustomSlot="true"
								        	@vdropzone-success="fileUploaded"
								        	@vdropzone-queue-complete="uploadComplete"
								        	@vdropzone-sending="uploadInProgress">
											<div class="dropzone-custom-content">
												<h5 class="dropzone-custom-title">
													<i class="fa fa-plus-circle text-success"></i> Drag and Drop Files to Upload
												</h5>
												<div class="subtitle">...or click to select files</div>
											</div>
								        </vue2-dropzone>

								        <div class="mt-2" v-if="upload_in_progress">
								            <i class="fa fa-spin fa-spinner"></i> Uploading File(s)
								        </div>

								        <span v-if="errors.additional_files" class="text-danger">
								            <span v-for="error in errors.additional_files">{{ error }}</span>
								        </span>

								        <div class="mt-2">
								        	<file-list :files="files" :editMode="true" :displayType="'list2.0'" />
								        </div>
								    </div>
								</div>
							</div>
						</div>

						<button type="button" class="btn btn-sm btn-success" v-on:click="saveInspection(this)" :disabled="saving" v-if="inspection.InspectionId">
						    Update Inspection <i class="fa fa-spin fa-spinner" v-if="saving"></i>
						</button>

				        <div v-if="!inspection.InspectionId" class="mt-2">
				        	<p class="alert alert-info">Save the Basic Inspection Information Before Starting the Assessment.</p>
				        </div>
				        <div v-else style="margin-top: 60px;">
					        <div v-for="(section, section_key) in sections" :id="`section-${section.InspectionSectionId}`">
					        	<div class="card mb-4">
					        		<div class="card-header">
					        			<strong>{{ section.DisplayOrder }}.0 {{ section.SectionName }}</strong>
					        			<div class="float-sm-right float-none mt-sm-0 mt-2">
					        				<b-dropdown variant="light" size="sm">
					        				    <template slot="button-content">
					        				        <i class="fa fa-sitemap"></i> Bulk Actions
					        				    </template>
					        				    <b-dropdown-item href="javascript:void(0)" v-on:click="markAll(section_key, complianceStatuses['Compliant'])">
					        				        <i class="fa fa-check-square"></i> All <strong>{{ labelCompliant }}</strong>
					        				    </b-dropdown-item>
					        				    <b-dropdown-item href="javascript:void(0)" v-on:click="markAll(section_key, complianceStatuses['N/A'])">
					        				        <i class="fa fa-ban"></i> All <strong>{{ labelNA }}</strong>
					        				    </b-dropdown-item>
					        				</b-dropdown>
					        			</div>
					        		</div>
					        		<div class="card-body" style="padding-top: 0.5rem; padding-bottom: 0.5rem;">
					        			<div :id="`section-${section.InspectionSectionId}-elements-table`" class="inspection-result">
					        				<div v-for="(element, element_key) in section.elements"
					        					:class="{'inspection-result-title': true, 'inspection-result-title-first': (element_key == 0 ? true : false), 'alert-danger': isNonCompliant(element)}">
					        					<div class="row pb-2">
						        					<div class="col-xl-6 col-lg-8 col-md-6 col-sm-12 mb-2">
						        						<span class="insp-element-text"><span style="margin-right: 10px;">{{ section.DisplayOrder }}.{{ element.DisplayOrder }}</span> {{ element.ElementText  }}</span>

						        						<div style="margin-left: 34px;">
						        							<a href="javascript:void(0)" v-if="element.Description && false" @click="setModalText(section.DisplayOrder, element)">View Description</a>

						        							<div class="text-muted">{{ element.Description }}</div>

						        							<a v-if="element.osha_standard_url" :href="element.osha_standard_url" target="_blank" :title="`View OSHA Standard: ${element.osha_standard_url}`">OSHA Standard</a>
						        						</div>
						        					</div>

						        					<div class="col-xl-4 col-lg-12 col-md-4 col-sm-12 mb-1">
					        							<b-form-radio-group :ref="`element-status-${element.InspectionElementId}`"
					        								v-model="element.result.ComplianceStatusId"
					        								@change="complianceStatusChanged(element,section_key,element_key,$event)"
					        								plain>
								        		            <b-form-radio :value="complianceStatuses['Compliant']"><strong>{{ labelCompliant }}</strong></b-form-radio>
								        		            <b-form-radio :value="complianceStatuses['Non-Compliant']"><strong>{{ labelNonCompliant }}</strong></b-form-radio>
								        		            <b-form-radio :value="complianceStatuses['N/A']"><strong>{{ labelNA }}</strong></b-form-radio>
								        		        </b-form-radio-group>
								        		    </div>

								        		    <div class="col-xl-2 col-lg-6 col-md-2 col-sm-12 my-2 my-sm-0">
								        		    	<i class="fa fa-spin fa-spinner" v-if="saving_result && saving_result == element.InspectionElementId"></i>

								        		    	<a href="javascript:void(0)"
								        		    		v-else-if="element.result && element.result.InspectionResultId"
								        		    		class="btn btn-sm btn-light"
								        		    		@click="togglePopup(section_key, element_key)">
								        		    		<span v-if="isNonCompliant(element)" class="text-danger">
								        		    			<i class="fa fa-plus"></i> Add Action
								        		    		</span>
								        		    		<span v-else>
								        		    			<i class="fa fa-edit"></i> Edit Details
								        		    		</span>
								        		    	</a>
								        		    </div>
								        		</div>
								        		<div class="inspection-element-details" v-if="element.result && hasResultDetails(element.result)">
													<div class="row mb-2" v-if="element.result.Comment">
														<div class="col-xl-2 col-lg-3 col-12 mb-lg-0 mb-1 text-lg-right text-muted">
															Comment:
														</div>
														<div class="col-xl-8 col-lg-9 col-12">
															{{ element.result.Comment }}
														</div>
													</div>
													<div class="row mb-2" v-if="element.result.total_positive_findings">
														<div class="col-xl-2 col-lg-3 text-lg-right text-muted">
															Positive Findings:
														</div>
														<div class="col-xl-8 col-lg-9 col-md-4 col-12">
															{{ element.result.total_positive_findings }}
														</div>
													</div>
													<div class="row mb-2" v-if="element.result.total_negative_findings">
														<div class="col-xl-2 col-lg-6 text-lg-righ text-mutedt">
															Negative Findings:
														</div>
														<div class="col-xl-8 col-lg-9 col-md-4 col-12">
															{{ element.result.total_negative_findings }}
														</div>
													</div>
													<div class="row mb-2" v-if="element.result.files && element.result.files.length > 0">
														<div class="col-xl-2 col-12 mb-xl-0 mb-2 text-xl-right text-muted">
															File(s) & Photo(s):
														</div>
														<div class="col-xl-8 col-12">
															<file-list :files="element.result.files" :canEdit="canEditFiles" :editMode="true" :displayType="'list2.0'" />
														</div>
													</div>

								        			<div class="row" v-if="isNonCompliant(element)">
								        				<div class="col-xl-2 col-12 mb-xl-0 mb-2 text-xl-right text-muted">
								        					Corrective Action(s):
								        				</div>
								        				<div class="col-xl-8 col-12">
								        					<a href="javascript:void(0)" class="btn-add-record mb-2" @click="togglePopup(section_key, element_key)" style="background: #ffffff;">
								        						<i class="fa fa-plus-circle text-danger"></i> Add Corrective Action
								        					</a>
								        					<corrective-action-table-list
								        						:actions="element.result.actions ? element.result.actions : []"
								        						view="cards"
								        						:hideActions="false"
								        						:canEditHelper="true"
								        						:editMode="true" />
								        				</div>
								        			</div>
								        		</div>
					        				</div>
					        			</div>
					        		</div>
					        	</div>
					        </div>
				        </div>
					</div>
				</div>

				<button type="button" class="btn btn-success" v-on:click="saveInspection(this)" :disabled="saving">
				    <span v-if="InspectionId">Update</span>
				    <span v-else>Create</span>
				    Inspection
				</button>
			</template>
		</div>
		<corrective-action-modal :ajaxMode="false" ref="correctiveActionModal" @actionSaved="saveAction" />
		<inspection-result-modal :InspectionId="inspection.InspectionId" ref="inspectionResultModal" @resultSaved="saveResult" />

		<b-modal v-model="openTextModal" :title="modalTitle" ref="detailTextModal" no-fade :no-close-on-backdrop="true" :ok-only="true" ok-title="Close" ok-variant="secondary">
			<label>{{modalText}}</label>
		</b-modal>
	</div>
</template>
<script>
	import moment from 'moment-timezone';
	import 'vue2-dropzone/dist/vue2Dropzone.min.css';

	export default {
	    data() {
	        return {
	        	userTimezone: this.$store.state.user.timezone,
	            loading: true,
	            loading_custom_fields: false,
	            saving: false,
	            upload_in_progress: false,
	            saving_result: null,
	            saving_files: null,
	            autoSaveId: null,
	            InspectionId: this.$route.params.id,
	            inspection: {},
	            divisions: [],
	            complianceStatuses: {},
	            sections: [],
	            files: [],
	            forms: [],
	            errors: {},
	            popup_element: null,
	            new_safety_member: {
	            	member_type: null,
	            },
	            custom_field_sections: [],
	            custom_fields: {},
	            personnel: [],

	            actionFields: [
	            	{key: 'status.status_name', label: 'Status'},
	            	{key: 'location', label: 'Location'},
	            	{key: 'due_date', label: 'Due Date'},
	            	{key: 'assignee_name', label: 'Assigned To'},
	            	{key: 'subcontractor', label: 'Subcontractor'},
	            	{key: 'detail', label: 'Details'},
	            ],

	            openTextModal: false,
	            modalTitle: '',
	            modalText: '',

	            InspectionDate: null,
	            test: null,
	            result_labels: null,
	            enable_insp_scmm: null,
	            form_settings: {},
	        }
	    },

	    watch: {
	    	'inspection.inspection_form_id'(newVal, oldVal){
	    		//Get the custom fields
	    		if(newVal == null || newVal == '')
	    		{
	    			//Reset
	    			this.custom_field_sections = [];

	    			//Stop
	    			return;
	    		}

	    		//Get it
	    		this.getCustomFieldSections();
	    	},
	    },

	    computed: {
	    	dropzoneOptions(){
	    		return {
					url: '/api/v1/files/upload?asset_type=Inspection&asset_id='+this.$route.params.id,
					headers: { "Authorization": "Bearer " + localStorage.getItem('app_token') }
				}
	    	},

	    	user() {
	    		return {
	    			FirstName: this.inspection.user_first_name,
	    			LastName: this.inspection.user_last_name,
	    			deleted_at: this.inspection.user_deleted_at,
	    		};
	    	},

	        SuperintendentValues(){
	            //check for null
	            if(!this.inspection.superintendent_id)
	            {
	                return {};
	            }

	            return {
	            	EmployeeId: this.inspection.superintendent_id,
            		FirstName: this.inspection.superintendent_first_name,
            		LastName: this.inspection.superintendent_last_name,
            		EmployeeNumber: this.inspection.EmployeeNumber,
            	};
	        },

	        JobsiteValues(){
	            //check for null
	            if(!this.inspection.JobsiteId)
	            {
	                //Check the store
	                if(this.$store.state.user.jobsite)
	                {
	                    var jobsite = this.$store.state.user.jobsite;

	                    //Set the HSE jobsite
                        this.inspection.JobsiteId = jobsite.JobsiteId;

                        //Set the GC
                        if(jobsite.general_contractor)
                        {
                        	this.inspection.GeneralContractor = jobsite.general_contractor;
                        }

                        //Send it
	                    return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
	                }

	                return null;
	            }

	            return {JobsiteId: this.inspection.JobsiteId, JobsiteNumber: this.inspection.JobsiteNumber, JobsiteName: this.inspection.JobsiteName};
	        },

	        EquipmentValues(){
	            //Check for Null
	            if(!this.inspection.equipment_id)
	            {
	                return null;
	            }

	            //Send it
	            return {
	                equipment_id: this.inspection.equipment_id,
	                model_number: this.inspection.model_number,
	                serial_number: this.inspection.serial_number,
	                equipment_name: this.inspection.equipment_name,
	                equipment_type_name: this.inspection.equipment_type_name
	            };
	        },

	        canEditFiles(){
	        	//Check the user ID against the record id
	        	if(this.inspection.UserId == this.$store.state.user.UserId)
	        	{
	        		return true;
	        	}

	        	//Check manager permission
	        	if(this.$root.hasPermission('inspections.manage'))
	        	{
	        		return true;
	        	}

	        	//Default
	        	return false;
	        },

	        safetyMembers(){
	        	//Send this for now
	        	return this.inspection.members;
	        },

	        labelCompliant(){
	        	//Check if set
	        	if(this.result_labels && this.result_labels.compliant)
	        	{
	        		return this.result_labels.compliant;
	        	}

	        	//Default
	        	return 'Compliant';
	        },

	        labelNonCompliant(){
	        	//Check if set
	        	if(this.result_labels && this.result_labels.noncompliant)
	        	{
	        		return this.result_labels.noncompliant;
	        	}

	        	//Default
	        	return 'Non-Compliant';
	        },

	        labelNA(){
	        	//Check if set
	        	if(this.result_labels && this.result_labels.na)
	        	{
	        		return this.result_labels.na;
	        	}

	        	//Default
	        	return 'N/A';
	        },

	        formOptions(){
	        	//Setup options
	        	var options = [];

	        	//Loop and Build
	        	var keys = Object.keys(this.forms);

	        	//Loop
	        	for (var i = keys.length - 1; i >= 0; i--)
	        	{
	        		//Append
	        		options.push({
	        			inspection_form_id: keys[i],
	        			form_name: this.forms[keys[i]],
	        		});
	        	}

	        	//Array sort
	        	return options.sort((a,b) => (a.form_name > b.form_name) ? 1 : ((b.form_name > a.form_name) ? -1 : 0));
	        },
	    },

	    methods: {
	    	setModalText(sectionDisplayOrder, element){
	    		//Set the title
	    		this.modalTitle = sectionDisplayOrder+'.'+element.DisplayOrder+' '+element.ElementText;
	    	    this.modalText = element.Description;
	    	    this.openTextModal = true;
	    	},

	        getInspection() {
	        	//Setup url
	        	var url = (this.InspectionId ? `inspections/edit-alt/${this.InspectionId}` : 'inspections/new');

	            //Get the data
	            this.$http
	                .get(url, this.$route.query)
	                .then(response => {
	                    //Set all the data
	                    this.inspection = response.data.inspection;
	                    this.divisions = response.data.divisions;
	                    this.complianceStatuses = response.data.complianceStatuses;
	                    this.sections = response.data.sections;
	                    this.files = response.data.files;
	                    this.forms = response.data.forms;
	                    this.enable_insp_scmm = response.data.enable_insp_scmm;

	                    //SEt the result Labels
	                    if(this.inspection.result_labels)
	                    {
	                    	//Decode and SEt
	                    	this.result_labels = JSON.parse(this.inspection.result_labels);
	                    }

	                	if (this.inspection.InspectionId || this.$route.query.clone_id)
	                	{
	                		this.inspection.members = JSON.parse(this.inspection.safety_committee_members || '[]');
	                		if (this.inspection.scmm_status_of_actions_flag === null)
	                    		this.inspection.scmm_status_of_actions_flag = -1;
                			if (this.inspection.scmm_lessons_learned_flag === null)
                	    		this.inspection.scmm_lessons_learned_flag = -1;
        	    			if (this.inspection.scmm_suggested_safety_flag === null)
        	    	    		this.inspection.scmm_suggested_safety_flag = -1;
	    	    			if (this.inspection.scmm_upcoming_activities_flag === null)
	    	    	    		this.inspection.scmm_upcoming_activities_flag = -1;
	    	    			if (this.inspection.scmm_proactive_measures_flag === null)
	    	    	    		this.inspection.scmm_proactive_measures_flag = -1;
	    	    			if (this.inspection.scmm_other_flag === null)
	    	    	    		this.inspection.scmm_other_flag = -1;
	                	}
	                	else
	                	{
	                		this.inspection.members = [];
	                	}

	                	if (this.inspection.InspectionDate)
	                	{
	                	    this.InspectionDate = moment(this.inspection.InspectionDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
	                	}

	                	if (this.inspection.JobsiteId === undefined)
	                	{
	                		this.$set(this.inspection, 'JobsiteId', null);
	                	}

	                	if (this.inspection.superintendent_id === undefined)
	                	{
	                		this.$set(this.inspection, 'superintendent_id', null);
	                	}

	                    //Set loading
	                    this.loading = false;
	                })
	                .catch(response => {

	                });
	        },

	        getCustomFieldSections(){
	        	//Set it
	        	this.loading_custom_fields = true;

	        	//Setup the ID
	        	var id = null;

	        	//Check Inspection if
	        	if(this.inspection.InspectionId)
	        	{
	        		id = this.inspection.InspectionId;
	        	}
	        	else if (this.$route.query.clone_id)
	        	{
	        		id = this.$route.query.clone_id;
	        	}

	        	//Get the data
	        	this.$http
	        	    .get('/inspections/custom-fields/' + this.inspection.inspection_form_id + (id ? '/'+id : '') )
	        	    .then(response => {
	        	    	//Check for the Values, MUST BE AN OBJECT
	        	    	if(response.data.custom_fields && !Array.isArray(response.data.custom_fields))
	        	    	{
	        	    		//Set the value
	        	    		this.custom_fields = response.data.custom_fields;
	        	    	}

	        	    	//Set the Personnel Fields
	        	    	//this.personnel = response.data.personnel;
	        	    	this.$refs.inspPersonnelForm.setPersonnel(response.data.personnel);

	        	    	//Set
	        	    	this.custom_field_sections = response.data.sections;

	        	    	//Set Helper
	        	    	this.form_settings = response.data.form_settings;

	        	    	//Older
	        	    	// this.hide_superintendent = response.data.hide_superintendent;
	        	    	// this.hide_equipment = response.data.hide_equipment;
	        	    	// this.req_superintendent = response.data.req_superintendent;
	        	    	// this.req_equipment = response.data.req_equipment;
	        	    })
	        	    .catch(error => {

	        	    })
	        	    .then(response => {
	        	        //SHow loading
	        	        this.loading_custom_fields = false;
	        	    });
	        },

	        markAll(section_key, status_id) {
	        	//Setup the Label
	        	let label = status_id == this.complianceStatuses['Compliant'] ? this.labelCompliant : this.labelNonCompliant;

	        	//Confirm
	        	if(!confirm('Are you sure you want to mark all items '+label+' in Section: '+this.sections[section_key].DisplayOrder+'. '+this.sections[section_key].SectionName))
	        	{
	        		return;
	        	}

	        	//Setup the Elements
	        	let payload = {
	        		ComplianceStatusId: status_id,
	        		InspectionSectionId: this.sections[section_key].InspectionSectionId,
	        		elements: [],
	        	};

	        	//Loop and Append
	        	for (var element of this.sections[section_key].elements)
	        	{
		        	//IF the element already has a result that is in the selected status, skip it
		        	if(element.result && element.result.InspectionResultId && element.result.ComplianceStatusId == status_id)
		        	{
		        		//Skip
		        		continue;
		        	}

		        	//Exclude those that are marked Non-Compliant
	        		if (element.result && element.result.ComplianceStatusId == this.complianceStatuses['Non-Compliant'])
	        		{
        				continue;
	        		}

	        		//Push it
	        		payload.elements.push({
	        			InspectionElementId: element.InspectionElementId,
	        			ElementDisplayOrder: element.DisplayOrder,
	        		});
	        	}

	        	//Send it
	        	this.$http
	        	.post(`inspections/multiple-results/${this.InspectionId}`, payload)
	        	.then(response => {
	        	    //Alert the user?
        	    	this.$toastr.success('Section ' + this.sections[section_key].DisplayOrder + '. ' + this.sections[section_key].SectionName + ' Marked ' + label);

        	    	//Loop and Populatre the Returned Results
        	    	for (var i = 0; i < response.data.length; i++)
        	    	{
        	    		//Setup Results
        	    		var result = response.data[i];

        	    		//Check the Response Element Display Order
        	    		if(this.sections[section_key].elements[(result.ElementDisplayOrder - 1)].result
        	    			&& this.sections[section_key].elements[(result.ElementDisplayOrder - 1)].result.InspectionResultId)
        	    		{
        	    			//Merge it
        	    			this.sections[section_key].elements[(result.ElementDisplayOrder - 1)].result.ComplianceStatusId = result.ComplianceStatusId;
        	    		}
        	    		else
        	    		{
        	    			//Set it
        	    			this.sections[section_key].elements[(result.ElementDisplayOrder - 1)].result = result;
        	    		}
        	    	}

	        	    this.$forceUpdate();
	        	});
	        },

	        safetyMemberEmployee(employee){
	        	//Setters
	        	this.new_safety_member.employee = employee;
	        	this.new_safety_member.craft = employee.TitleName || employee.position;
	        	this.new_safety_member.company = this.$store.state.user.account_name;

	        	//Without this, it won't re-render the input names
	        	this.$forceUpdate();
	        },

	        safetyMemberUser(user){
	        	//Setters
	        	this.new_safety_member.user = user;
	        	this.new_safety_member.craft = user.title;
	        	this.new_safety_member.company = this.$store.state.user.account_name;

	        	//Without this, it won't re-render the input names
	        	this.$forceUpdate();
	        },

	        addSafetyCommitteeMemberAlt(){
	        	//Debugging
	        	//console.log(this.new_safety_member);

	        	//Validation
	        	if(!this.new_safety_member.member_type)
	        	{
	        		this.$toastr.error('Member Type is Required');
	        		return;
	        	}

	        	//Validation
	        	if(!this.new_safety_member.craft || this.new_safety_member.craft == '')
	        	{
	        		this.$toastr.error('Member Craft is required');
	        		return;
	        	}

	        	//Validation
	        	if(!this.new_safety_member.company || this.new_safety_member.company == '')
	        	{
	        		this.$toastr.error('Member Company is required');
	        		return;
	        	}

	        	//Validation
	        	if(this.new_safety_member.member_type == 'Employee' && !this.new_safety_member.employee)
	        	{
	        		this.$toastr.error('Employee is Required');
	        		return;
	        	}

	        	//Validation
	        	if(this.new_safety_member.member_type == 'User' && !this.new_safety_member.user)
	        	{
	        		this.$toastr.error('User is Required');
	        		return;
	        	}

	        	//Validation
	        	if(this.new_safety_member.member_type == 'FreeText' && (!this.new_safety_member.member_name || this.new_safety_member.member_name == ''))
	        	{
	        		this.$toastr.error('Member Name is Required');
	        		return;
	        	}

	        	//Build the member
	        	var member = {
	        		type: this.new_safety_member.member_type,
	        		craft: this.new_safety_member.craft,
	        		company: this.new_safety_member.company,
	        	};

	        	//Switch
	        	switch(this.new_safety_member.member_type)
	        	{
	        		case 'Employee':
	        			member.EmployeeId = this.new_safety_member.employee.EmployeeId;
	        			member.name = this.new_safety_member.employee.FirstName + ' ' + this.new_safety_member.employee.LastName;
	        			break;
	        		case 'User':
	        			member.UserId = this.new_safety_member.user.UserId;
	        			member.name = this.new_safety_member.user.FirstName + ' ' + this.new_safety_member.user.LastName;
	        			break;
	        		case 'FreeText':
	        			member.name = this.new_safety_member.member_name;
	        			break;
	        	}

	        	//Reset
	        	this.inspection.members.push(member);
	        	this.new_safety_member = {
	        		member_type: null,
	        	};
	        },

	        onSuperSelect(employee){
	            if (employee == null)
	            {
	                this.inspection.superintendent_id = null;
	                return;
	            }

	            this.inspection.superintendent_id = employee.EmployeeId;
	        },

	        superCreated(employee){
	            this.inspection.superintendent_id = employee.EmployeeId;
	            this.inspection.superintendent_name = employee.FirstName + ' ' + employee.LastName;
				this.inspection.superintendent_first_name = employee.FirstName;
				this.inspection.superintendent_last_name = employee.LastName;
				this.inspection.EmployeeNumber = employee.EmployeeNumber;

	            //We have to call the employee-select helper function
	            //because component props are ONE WAY databound.
	            this.$refs.inspSuperSelect.setSelectedValues(this.SuperintendentValues);
	        },

	        showNewSuperModal(){
	            //Show it
	            this.$refs.newSuperModal.show();
	        },

	        onJobSiteSelectUpdate (jobsite) {
	            //Check for null
	            if(jobsite == null)
	            {
	                //Stop
	                this.inspection.JobsiteId = null;
	                return;
	            }

	            //Send the value
	            this.inspection.JobsiteId = jobsite.JobsiteId;
	            this.inspection.JobsiteName = jobsite.JobsiteName;
	            this.inspection.JobsiteNumber = jobsite.JobsiteNumber;

	            //Set the GC
	            if(jobsite.general_contractor)
	            {
	            	this.inspection.GeneralContractor = jobsite.general_contractor;
	            }
	        },

	        jobsiteCreated(jobsite){
	            //How do we show the
	            this.inspection.JobsiteId = jobsite.JobsiteId;
	            this.inspection.JobsiteNumber = jobsite.JobsiteNumber;
	            this.inspection.JobsiteName = jobsite.JobsiteName;

	            //We have to call the employee-select helper function
	            //because component props are ONE WAY databound.
	            this.$refs.inspJobsiteSelect.setValue(this.JobsiteValues);
	        },

	        showNewJobsiteModal(){
	            //Show it
	            this.$refs.newJobsiteModal.show();
	        },

	        onEquipmentSelect(equipment){
	            if (equipment == null)
	            {
	                this.inspection.equipment_id = null;
	                return;
	            }

	            this.inspection.equipment_id = equipment.equipment_id;
	        },

	        togglePopup(section_key, element_key, status_id = null) {
	        	//Fetch the Element
	        	var element = this.sections[section_key].elements[element_key];

	        	//Check for Non-Compliant
	        	if ( (status_id && status_id == this.complianceStatuses['Non-Compliant']) || (element.result && element.result.ComplianceStatusId == this.complianceStatuses['Non-Compliant']) )
	        	{
	        		//Stop Here
	        		if(this.inspection.is_public_form === 1 && this.inspection.enable_corrective_actions !== 1)
	        		{
	        			return;
	        		}

	        		//Track the element being editing
	        		this.popup_element = element;

	        		//Set the Element on the Modal
	        		this.$refs.correctiveActionModal.setElement(element);

        			// Set the id for the modal
        			this.$refs.correctiveActionModal.setAction({});

        			//Show the Modal
        			this.$refs.correctiveActionModal.showModal();
	        	}
	        	else
	        	{
	        		//Track the element being editing
	        		this.popup_element = element;

	        		//Set the Element on the Modal
	        		this.$refs.inspectionResultModal.setElement(element);

	        		//Set the Result Model
	        		this.$refs.inspectionResultModal.setModel(element.result);

	        		//Show the Modal
	        		this.$refs.inspectionResultModal.showModal();
	        	}
	        },

	        complianceStatusChanged (element, section_key, element_key, status_id) {
	        	// element object has the new value, but the actual member has the old value... so... yeah...
	        	let old_status_id = element.result && element.result.ComplianceStatusId ? element.result.ComplianceStatusId : null;

	        	//Log the element
	        	//console.log(element);

				//Check if we are changes a Non-Compliant Item to Compliant or N/A && there are actions
				//This lets the user know that we will be deleted the actions
				if (old_status_id == this.complianceStatuses['Non-Compliant']
					&& element.actions
					&& element.actions.length > 0
					&& !confirm('Are you sure you want to mark this result as '+this.labelCompliant+'? It has '+this.labelNonCompliant+' Corrective Action(s) attached to it. These will be deleted if you proceed.'))
				{
					//Ask the user if they are sure they want to make this change because this will
					//delete the corrective action attached to the result
					//Revert the status to Non-Compliant
					this.sections[section_key].elements[element_key].result.ComplianceStatusId = this.complianceStatuses['Non-Compliant'];

					//Force Re-render
					//this.$forceUpdate();

					//Stop here
					return;
				}

				//Fire the Save Function
				if (status_id != this.complianceStatuses['Non-Compliant'] || this.inspection.req_corrective_actions == 0)
				{
					//Set Helper
					this.saving_result = element.InspectionElementId;

					//Send it
					this.$http
					.post(`inspections/result/${this.InspectionId}`, {
						InspectionElementId: element.InspectionElementId,
						InspectionResultId: element.result && element.result.InspectionResultId ? element.result.InspectionResultId : null,
						ComplianceStatusId: status_id,
					})
					.then(response => {
					    //Alert the user?
				    	this.$toastr.success('Result Saved');

					    //Update the Element
					    //this.sections[section_key].elements[element_key].result.ComplianceStatusId = status_id;
					    this.sections[section_key].elements[element_key].result = response.data;

					    //Emit
					    //this.$emit('resultSaved', response.data);

					    //Force the Update
					    //this.$forceUpdate();
					})
					.catch(error => {
						//Handle Validation Errors

						//Reset or Log?
						console.log(error);
					})
					.then(response => {
					    //SHow loading
					    this.saving = false;
					    this.saving_result = null;
					});
				}
				else
				{
					//Force the Update
					//his.$forceUpdate();

					//Show the Popup
					this.togglePopup(section_key, element_key, status_id);
				}
        	},

        	formatResult(data){
        		//Consolidate the Result into the Format that We Need
        		var result = data.result;

        		//Set the files
        		result.files = data.files;

        		//Check for actions
        		if(data.action)
        		{
        			//Setup
        			if(!result.actions)
        			{
        				result.actions = [];
        			}

        			//Push the action
        			result.actions.push(data.action);
        		}

        		//Send it
        		return result;
        	},

        	saveResult(result) {
		        //Set the Files
		        let element = this.popup_element;

		        //PUsh the Element
    			this.sections[(element.section_display_order - 1)].elements[(element.DisplayOrder - 1)].result = result;

        		//Do the Update
        		this.$forceUpdate();
        	},

        	saveAction(action){
        		//Grab the Elemetn
        		let element = this.popup_element;

        		//We need to make sure the user actually saved the
        		if(!action.corrective_action_id && !action.validate_only)
        		{
        			//The user did not save the action, rather they exited or hit "cancel"
        			//We need to reset the element Compliance Status ID
        			this.sections[(element.section_display_order - 1)].elements[(element.DisplayOrder - 1)].result.ComplianceStatusId = null;

        			//Stop Here
        			return;
        		}

        		//Build the Payload
        		let data = {
        			'InspectionElementId': element.InspectionElementId,
        			'InspectionResultId': element.InspectionResultId, //We don't really need this
        			//'ComplianceStatusId': element.ComplianceStatusId,
        			'ComplianceStatusId': this.complianceStatuses['Non-Compliant'],
        			'action': action //This is the action emitted from the modal, it will have all the data we need
        		};

        		//Set the Helper
        		this.saving_result = element.InspectionElementId;

        		//Send it
    			this.$http
    			.postWithFiles(`inspections/result/${this.inspection.InspectionId}`, data, action.new_files)
    			.then(response => {
    			    //Alert the user?
    			    this.$toastr.success('Result Saved');

    			    //PUsh the Element
    			    this.sections[(element.section_display_order - 1)].elements[(element.DisplayOrder - 1)].result = response.data;

    			    //Reset
    			    this.popup_element = null;

    			    //Setu p
    			    this.$forceUpdate();
    			})
    			.catch(error => {
    			    //Check for error
    			    if(error.response && error.response.status === 422)
    			    {
    			    	let temp_errors = error.response.data;
    			    	let final_errors = {};
    			    	for (let key in temp_errors)
    			    	{
    			    		let key_words = key.split('.')
    			    		if (key_words[0] != 'action')
    			    			continue;

    			    		final_errors[key_words[1]] = temp_errors[key]
    			    	}
    			        //Display validation errors
    			        //this.$refs.correctiveActionModal.setErrors(final_errors);
    			    }
    			    else
    			    {
    			    	console.log(error);
    			    }
    			})
    			.then(response => {
    			    //SHow loading
    			    this.saving = false;
    			    this.saving_result = null;
    			});
        	},

	        saveInspection() {
	            //Show loading
	            this.saving = true;

	            //Reset the errors
	            this.errors = {};
	            this.$refs.inspPersonnelForm.setErrors({});

	            //Check for Members
	            if (this.inspection.members === [])
	            {
	            	this.inspection.members = null;
	            }

	            if (this.InspectionDate)
	            {
	                this.inspection.InspectionDate = moment(this.InspectionDate, 'MM/DD/YYYY').format('YYYY-MM-DD');
	            }

	            //Helpers
	            this.inspection.include_custom_fields = true;
	            this.inspection.custom_fields = this.custom_fields;
	            this.inspection.personnel = this.$refs.inspPersonnelForm.getPersonnel();

	            //Send it
	            this.$http
	            .post('inspections/edit', this.inspection)
	            .then(response => {
	                //Alert the user?
	                this.$toastr.success('Inspection Saved');

	                if (response.data.is_new)
	                {
	                	this.$router.push(`/inspections/edit/${response.data.inspection.InspectionId}`);
	                }
	                else
	                {
	                	this.$router.push(`/inspections/view/${response.data.inspection.InspectionId}`);
	                }
	            })
	            .catch(error => {
	                //Check for error
	                if(error.response.status === 422)
	                {
	                    //Display validation errors
	                    this.errors = error.response.data;

	                    //Set the errors
	                    this.$refs.inspPersonnelForm.setErrors(this.errors);

	                    //Setup Keys
	                    var keys = Object.keys(this.errors);

	                    //Alert the valiation errors for the user to see
	                    var html = '<ul>';

	                    //Loop through the errors and alert
	                    for (var i = 0; i < keys.length; i++)
	                    {
	                        for (var j = 0; j < this.errors[keys[i]].length; j++)
	                        {
	                            //Append to HTML
	                            html += '<li>'+this.errors[keys[i]][j]+'</li>';
	                        }
	                    }

	                    //Close it
	                    html += '</ul>';

	                    //Alert it
	                    this.$toastr.error(html);
	                }
	            })
	            .then(response => {
	                //Show loading
	                this.saving = false;
	            });
	        },

	        autoSave(){
	        	//Make sure we hvae an ID
	        	if(!this.inspection.InspectionId)
	        	{
	        		return;
	        	}

	        	//Helpers
	        	this.inspection.include_custom_fields = true;
	        	this.inspection.custom_fields = this.custom_fields;
	        	this.inspection.personnel = this.$refs.inspPersonnelForm.getPersonnel();

	            //Send it
	            this.$http
	            .post('inspections/edit?auto_save=true', this.inspection)
	            .then(response => {
	                //Do nothing
	            })
	            .catch(error => {
	                //Check for error
	                if(error.response && error.response.status === 422)
	                {
	                    //Display validation errors
	                    //this.errors = error.response.data
	                }
	                else
	                {
	                	console.log(error);
	                }

	                //Clear the interval on any error
	                this.clearAutoSave();
	            })
	        },

	        setAutoSave(){
	            //Space
	            const self = this;

	            //Set it
	            this.autoSaveId = setInterval(function(){
	                //Fire Auto save
	                self.autoSave();
	            }, 30000);
	        },

	        clearAutoSave(){
	            //Clear it
	            clearInterval(this.autoSaveId);

	            //Set it
	            this.autoSaveId = null;
	        },

	        fileUploaded(file, response){
	        	//Push onto the stack
	        	this.files.push(response);

	        	//Alert the user? This would fire SEVERAL alerts, we don't want that.

	        	//Remove the file?
	        	this.$refs.inspAdditionalFiles.removeFile(file);
	        },

	        uploadInProgress(file, xhr, formData){
                //We just want to show the helper
                this.upload_in_progress = true;
            },

	        uploadComplete(){
	        	//Alert the user
	        	this.$toastr.success('File(s) Uploaded');

	        	//We just want to show the helper
                this.upload_in_progress = false;
	        },

	        uploadFiles(result_id, event){
	        	//Setup
	        	this.saving_files = result_id;

	        	//Post the Files
	        	this.$http.postWithFiles('/files/upload', {asset_type: 'InspectionResult', asset_id: result_id}, event.srcElement.files)
	        		.then((data) => {
	        			//Alert the user?

	        			//Push Files Onto the Stack?
	        		})
	        		.catch(() => {
	        			//Handle Errors?
	        		})
	        		.then(() => {
	        			//Reset
	        			this.saving_files = null;
	        		});
            },

	        setCustomFields(fields){
                //Set it
                this.custom_fields = fields;
            },

            isNonCompliant(element){
            	return (element.result && element.result.ComplianceStatusId == this.complianceStatuses['Non-Compliant']);
            },

            hasResultDetails(result){
            	//Check if ANY of the details are populated
            	if(result.Comment)
            	{
            		return true;
            	}

            	//Check Files
            	if(result.files && result.files.length > 0)
            	{
            		return true;
            	}

            	//Check Findings
            	if(result.total_positive_findings || result.total_negative_findings)
            	{
            		return true;
            	}

            	//Check Corrective Actions
            	if(result.actions && result.actions.length > 0)
            	{
            		return true;
            	}

            	//No
            	return false;
            }
	    },

	    mounted() {
	        //Get the inspections
	        this.getInspection();

	        //Check for an id
	        if(this.InspectionId)
	        {
	        	//Set the auto-save
	        	this.setAutoSave();
	        }
	    },

	    beforeDestroy(){
	        //Clear it
	        this.clearAutoSave();
	    }
	}
</script>

<style type="text/css" scoped>
	.vue-dropzone {
		border: 2px dashed #e5e5e5;
	}
</style>